import React from 'react';

const AccessibilityStatement: React.FC = () => {
  return (
    <div className="content-shell">
      <h1>הצהרת נגישות</h1>
      <p>
        המטרה של אתר זה היא להבטיח גישה הוגנת ונוחה לכל המשתמשים, לרבות אנשים עם מוגבלויות. אנו שואפים לאמץ עקרונות נגישות ולהמשיך לשפר את חוויית המשתמש.
      </p>
      <h2>מה עשינו עד היום</h2>
      <ul>
        <li>הוספת תוויות (labels) ו־ARIA לשדות טפסים קריטיים.</li>
        <li>הוספת קישור "דלג לתוכן" לנווט במהירות באמצעות מקלדת.</li>
        <li>שיפורי סגנונות פוקוס כדי להבטיח כי רכיבי טופס וכפתורים ברורים בעת ניווט בטאב.</li>
        <li>כלי נגישות המאפשר ניגודיות גבוהה, הגדלת טקסט והפחתת תנועה.</li>
      </ul>
      <h2>מה עוד נעשה</h2>
      <p>
        אנו מתכננים להריץ בדיקות אוטומטיות (axe-core) כחלק מתהליך ה־CI ולתקן בעיות נגישות נוספות. כמו כן נשפר את השימושיות של המסכים עם קוראי מסך ונבצע בדיקות ידניות עם משתמשים.
      </p>
      <h2>פניית משוב</h2>
      <p>
        אם נתקלתם בבעיה נגישות באתר, אנא צרו קשר דרך דף "צור קשר" וציינו את הפרטים: הדפדפן, מערכת ההפעלה, תיאור הבעיה וכתובת הדף.
      </p>
      <p style={{ marginTop: 24 }}>תאריך עדכון: {new Date().toLocaleDateString('he-IL')}</p>
    </div>
  );
};

export default AccessibilityStatement;
